const ContentCard = ({ children, className = "" }) => {
  return (
    <div
      className={`bg-white border border-[#E3E3E3] rounded-[10px] p-5 ${className}`}
    >
      {children}
    </div>
  );
};

export default ContentCard;
